import { ClipLoader } from "react-spinners";

/**
 * A standalone loading spinner used as the <Suspense> fallback for
 * lazy-loaded route chunks. This component is intentionally Redux-free
 * because it renders before any feature store is composed.
 */
const SuspenseFallback = () => {
  return (
    <div
      className="suspense-fallback"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1301,
      }}
    >
      <div
        className="spinner-background"
        style={{
          display: "flex",
          borderRadius: "20px",
          width: "80px",
          backgroundColor: "#9c9c9cd6",
          height: "80px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ClipLoader color="#2b81b9" loading={true} />
      </div>
    </div>
  );
};

export default SuspenseFallback;
